import { styled } from 'styled-components';

import Table from 'src/components/CrudCommonComponents/Table';

export const StyledTable = styled(Table)`
  margin-top: -1.2rem;
  height: 26.5rem;
  font-weight: 400;

  .ant-table-thead > tr > .ant-table-cell {
    font-weight: 600;
    color: #252525;
  }

  .ant-table-tbody > tr > .ant-table-cell {
    font-weight: 400;
    padding: 0.4rem 0.8rem !important;
  }
`;

export const StyledPatientName = styled.div`
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration: none;
  }
`;

export const BoldItem = styled.span`
  font-weight: 700;
`;

export const LocationItem = styled.span`
  color: #4f595b;
`;
